/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BranchCircleIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Branch Circle',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="24" cy="24" r="2" />
    <circle cx="24" cy="12" r="2" />
    <path
      d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2Zm-3.8 16a4.2 4.2 0 0 1-.069.683l6.527 2.8a4.425 4.425 0 1 1-.79 1.837l-6.528-2.8a4.2 4.2 0 1 1 0-5.04l6.528-2.8a4.219 4.219 0 1 1 .791 1.837l-6.528 2.8A4.2 4.2 0 0 1 14.2 18Z"
    />
  </svg>`;
};
